import { Inject, Injectable } from '@angular/core';
import { ProductPriceLog, ProductPriceLogRepository } from '@infrab4a/connect';
import { ConnectRequest } from 'src/app/models';
import { BaseConnectService } from './base-connect.service';

@Injectable({
  providedIn: 'root'
})
export class ShopProductPriceLogService extends BaseConnectService<ProductPriceLog> {
  constructor(
    @Inject('ProductPriceLogRepository')
    readonly productPriceLogRepository: ProductPriceLogRepository
  ) {
    super(productPriceLogRepository);
  }

  async getPaginatedList(request: Partial<ConnectRequest>) {
    const result = await this.paginatedSearch(request);
    const content = result.data.map((log) => ({ ...log }));
    const totalPages = request.pageSize
      ? Math.floor(result.count / request.pageSize)
      : undefined;
    const totalElements = result.count;

    return {
      totalPages,
      totalElements,
      content,
      empty: result.count === 0
    };
  }

  async getLatestByProduct(productId?: string, ean?: string) {
    if (productId) {
      const byProductId = await this.getLatestLog({
        field: 'productId',
        value: productId
      });
      if (byProductId) {
        return byProductId;
      }
    }

    if (ean) {
      return this.getLatestLog({ field: 'productEAN', value: ean });
    }

    return null;
  }

  private async getLatestLog(filter: { field: string; value: string }) {
    const result = await this.getPaginatedList({
      page: 0,
      pageSize: 1,
      sortBy: 'createdAt',
      sortDirection: 'desc',
      filters: [{ field: filter.field, value: filter.value, condition: 'equals' }]
    });
    return result.content[0] ?? null;
  }
}
